// import axios from 'axios'
import baseURL from '../baseUrl'

// 设置用户信息
export function setuserinfo(data) {
  var url=baseURL?'/pc_updateInfo':'/api/pc_updateInfo'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 获取用户信息
export function getuserinfo(data) {
  var url=baseURL?'/pc_userInfo':'/api/pc_userInfo'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 我的收藏
export function myFavorite(data) {
  var url=baseURL?'/getUserFavorList':'/api/getUserFavorList'
  return axios({
    // url: '/pc_myFavorite',
    url,
    method: 'post',
    params: data
  })
}


// 加入/取消 收藏商品
export function goodsColl(data) {
  var url=baseURL?'/pc_goodsColl':'/api/pc_goodsColl'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 加入/取消 收藏店铺
export function supplierColl(data) {
  var url=baseURL?'/pc_supplierColl':'/api/pc_supplierColl'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

// 获取未读消息总数
export function getMessageTypeUnreadCount(data) {
  var url=baseURL?'/getMessageTypeUnreadCount':'/api/getMessageTypeUnreadCount'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/my/my.js